import React from 'react';
import styled from 'styled-components';
import { Pen, Eraser, Square, Circle, Type } from 'lucide-react';

const ToolbarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: #333;
  border-bottom: 1px solid #444;
  min-height: 50px;
`;

const ToolButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 8px;
  background: ${props => props.active ? '#3b82f6' : 'rgba(255, 255, 255, 0.1)'};
  color: white;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: ${props => props.active ? '#2563eb' : 'rgba(255, 255, 255, 0.2)'};
  }
`;

const ToolbarPanel = ({ currentTool, setCurrentTool }) => {
  const tools = [
    { id: 'pen', icon: Pen, label: 'Pen' },
    { id: 'eraser', icon: Eraser, label: 'Eraser' },
    { id: 'rectangle', icon: Square, label: 'Rectangle' },
    { id: 'circle', icon: Circle, label: 'Circle' },
    { id: 'text', icon: Type, label: 'Text' }
  ];

  return (
    <ToolbarContainer>
      {tools.map(tool => {
        const Icon = tool.icon;
        return (
          <ToolButton
            key={tool.id}
            active={currentTool === tool.id}
            onClick={() => setCurrentTool(tool.id)}
            title={tool.label}
          >
            <Icon size={20} />
          </ToolButton>
        );
      })}
    </ToolbarContainer>
  );
};

export default ToolbarPanel;
